import PropTypes from 'prop-types';

// material-ui
import { Box } from '@mui/material';

// project import
import MainCard from 'ui-component/cards/MainCard';

// ==============================|| AUTHENTICATION CARD WRAPPER ||============================== //

const HomeCardWrapper = ({ children, ...other }) => (
  <MainCard
    sx={{
      maxWidth: { xs: 600, md: 800, sm: 600, lg: 700,xl:700 },
      
      '& > *': {
        flexGrow: 1,
        flexBasis: '50%'
      },
       backgroundColor:'#F7F7F7'
    }}
    content={false}
    {...other}
  >
    <Box sx={{ p: { xs: 2, sm: 3, xl: 5 } }}>{children}</Box>
  </MainCard>
);

HomeCardWrapper.propTypes = {
  children: PropTypes.node
};

export default HomeCardWrapper;
